// Libraries
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

// Components
import Row from 'ui/Row'
import Col from 'ui/Col'
import LoginBanner from 'ui/LoginBanner'
import RegisterCheckCode from 'components/Register/RegisterCheckCode'
import RegisterNominate from 'components/Register/RegisterNominate'

// Use
import { useDesktop } from 'use/media'
import useQuery from 'use/query'
import useMounted from 'use/mounted'

// Api
import { checkRef } from 'api/register'

// Services
import loading from 'services/loading'

// Path
import { PATH_NOT_FOUND, PATH_REGISTER_EXISTED } from 'routes/paths'

export default function PageRegister() {
  // State
  const [isCodeChecked, setCodeChecked] = useState(false)
  const [vendorEmail, setVendorEmail] = useState('')
  const [preloader, setPreloader] = useState(true)

  // Use hook
  const isDesktop = useDesktop()
  const history = useHistory()
  const isMounted = useMounted()
  const { ref } = useQuery()

  useEffect(() => {
    loading.show()

    checkRef(ref)
      .then(({ firstLogin, email }) => {
        if (!firstLogin) {
          history.push(PATH_REGISTER_EXISTED)
        }

        setVendorEmail(email)
      })
      .catch(() => {
        history.push(PATH_NOT_FOUND)
      })
      .finally(() => {
        loading.hide()

        if (isMounted.current) {
          setPreloader(false)
        }
      })
  }, [history, ref, isMounted])

  if (preloader) {
    return <div></div>
  }

  return (
    <Row noGutters style={{ height: isDesktop ? '100vh' : 'auto' }}>
      <Col
        sm={{ span: 12, vcenter: true }}
        md={{ span: 6, vcenter: true }}
        lg={{ span: 6, vcenter: true }}
      >
        <LoginBanner />
      </Col>
      <Col
        sm={{ span: 12, vcenter: true }}
        md={{ span: 6, vcenter: true }}
        lg={{ span: 6, vcenter: true }}
      >
        {isCodeChecked ? (
          <RegisterNominate vendorEmail={vendorEmail} />
        ) : (
          <RegisterCheckCode
            onSubmit={() => {
              setCodeChecked(true)
            }}
          />
        )}
      </Col>
    </Row>
  )
}
